export const allowedDomain = ['app.prophecy.io', 'app.prophecy.ai'];
export const UTM_SESSION_KEY = 'prophecy_utm_params_session';
export const UTM_COOKIE_NAME = 'prophecy_utm_params';

export const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'hsa_acc',
  'hsa_cam',
  'hsa_grp',
  'hsa_ad',
  'hsa_net',
  'hsa_ver',
  'li_fat_id',
  'gclid',
  'gad_source'
] as const;

// Meta Pixel
export const allowedMetaPixelDomains = ['app.prophecy.ai'];
export const META_PIXEL_ID = '1504545091379496'; // Prophecy Meta Pixel ID

// OpenAI (ChatGPT Ads) Measurement Pixel — https://developers.openai.com/ads/measurement-pixel
export const allowedOpenAIPixelDomains = ['app.prophecy.ai'];
export const OPENAI_PIXEL_ID = '3bCBH2fTBccrrq7PCXmkyQ';

// HubSpot OAuth signup tracking
// Set in localStorage before Google OAuth redirect; read and cleared post-login to create HubSpot contact
export const OAUTH_SIGNUP_FLAG_KEY = 'prophecy_oauth_signup_pending';
